import { keys } from '../keys';
import {
  createBillingConfig,
  PriceInterval,
  PriceModel,
  PriceType
} from './schema';

enum Feature {
  AICustomerScoring = 'AI Contact Scoring',
  SmartEmailAnalysis = 'Smart Email Analysis',
  LeadPredictions = 'Lead Predictions',
  SentimentAnalysis = 'Sentiment Analysis',
  DataStorage = 'Data Storage',
  ExtendedSupport = 'Extended Support'
}

const currency = 'USD';

export const billingConfig = createBillingConfig({
  products: [
    {
      id: 'trial',
      name: 'Limited Trial',
      description: 'Free access with limited features.',
      label: 'Get started',
      recommended: true,
      features: [
        Feature.AICustomerScoring,
        Feature.SmartEmailAnalysis,
        Feature.SentimentAnalysis,
        Feature.LeadPredictions
      ],
      plans: [
        {
          id: 'plan-trial-month',
          displayIntervals: [PriceInterval.Month],
          prices: [
            {
              id:
                keys().NEXT_PUBLIC_BILLING_PRICE_TRIAL_MONTH_ID ||
                'price-trial-month-id', // keep for marketing pages, so you only need to specify id in dashboard
              interval: PriceInterval.Month,
              type: PriceType.Recurring,
              model: PriceModel.Flat,
              cost: 0.0,
              currency
            }
          ]
        }
      ]
    }
  ]
});

export const billingConfigDisplayIntervals = Array.from(
  new Set(
    billingConfig.products
      .filter((product) => !product.hidden)
      .flatMap((product) =>
        product.plans.flatMap((plan) => plan.displayIntervals)
      )
      .filter(Boolean)
  )
) as PriceInterval[];
